/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
  faCalendarAlt,
  faMoneyBill,
  faFilter,
  faCheckCircle,
  faFileExcel,
  faWarning,
  faFileUpload,
} from '@fortawesome/free-solid-svg-icons';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import moment from 'moment';
import Swal from 'sweetalert2';
import { formatCount, isValidIndianPhoneNumber, isValidName } from '../../components/Validators';
import CountUp from '../../components/CountUp';
import Search from '../../components/Search';
import LoadingModal from '../../components/LoadingModal';
import logoImg from '../../assets/images/logo.png';
import {
  getAllNewUserPendingHprDfRequestDetailsByType,
  getAllNewUserCompletedHprDfRequestDetailsByType,
  searchByPhonePendingNewUsers,
  searchByPhoneCompletedNewUsers,
  filterNewUserHprDfUsersCompletedrequests,
  filterNewUserHprDfUsersPendingrequests,
  exportHprDfUsers,
  exportExcelForCompleted,
  getcountDigitalRegistraion,
  bulkUploadEapi,
  exportVetExcel,
  // sapexportHprDfUsers,
  // sapExportExcelForCompleted,
} from '../../store/modules/newUser/actions';
import {
  selectCompletedUser,
  selectIsLoading,
  selectPendingUser,
  selectDigitalRegistrationCount,
} from '../../store/modules/newUser/selectors';
import ModalForHprFilter from '../../components/ModalForHprFilter';
import withScreenRefreshDetection from '../../utils/withScreenRefreshDetection';
import './PendingHprDfRegistration.scss';
import Spinner from '../../components/Spinner';

const pendingHprDfRegistration = (props) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [query, setQuery] = useState(null);
  const [showFilterModal, setshowFilterModal] = useState(false);
  const dispatch = useDispatch();
  const role = localStorage.getItem('role');
  const email = localStorage.getItem('email');
  const [filters, setFilters] = useState({
    fromDate: null,
    plantCode: null,
    mobileNumber: null,
    toDate: null,
    regionName: null,
    vendorCode: null,
  });

  // Loading states for buttons
  const [isVendorExportLoading, setIsVendorExportLoading] = useState(false);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isFarmerExportLoading, setIsFarmerExportLoading] = useState(false);
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const upcoming = useSelector((state) => selectPendingUser(state));
  const pastHeld = useSelector((state) => selectCompletedUser(state));
  const count = useSelector((state) => selectDigitalRegistrationCount(state));
  const isLoading = useSelector((state) => selectIsLoading(state));
  const filterAppliedForWaitingUsers = localStorage.getItem(
    'isFilterAppliedForWaitingUsers',
  );
  const filterAppliedForCompletedUsers = localStorage.getItem(
    'isFilterAppliedForCompletedUsers',
  );

  const values = {
    page: 1,
    limit: 10,
  };
  // Helper function to determine rejection status
  const isRejected = (item) => (
    item.approvedByPlantIc === 'rejected'
    || item.approvedByRHPI === 'rejected'
    || item.approvedByRIFA === 'rejected'
    || item.approvedByEAPI === 'rejected'
  );
  const fetchDetailsBasedOnStates = () => {
    if (tabIndex === 0) {
      dispatch(getAllNewUserPendingHprDfRequestDetailsByType(values));
    } else if (tabIndex === 1) {
      values.requestType = 'completed';
      dispatch(getAllNewUserCompletedHprDfRequestDetailsByType(values));
    } else if (tabIndex === 2) {
      values.requestType = 'rejected';
      dispatch(getAllNewUserCompletedHprDfRequestDetailsByType(values));
    }
  };

  const handleConfirmPendingUsers = () => {
    localStorage.removeItem('isFilterAppliedForWaitingUsers');
    fetchDetailsBasedOnStates();
  };

  const handleConfirmCompletedUsers = () => {
    localStorage.removeItem('isFilterAppliedForCompletedUsers');
    fetchDetailsBasedOnStates();
  };
  const handleRefresh = (response) => {
    if (response) {
      dispatch(getAllNewUserPendingHprDfRequestDetailsByType(values));
      dispatch(getAllNewUserCompletedHprDfRequestDetailsByType(values));
    }
  };

  useEffect(() => {
    if (tabIndex === 0 && filterAppliedForWaitingUsers) {
      Swal.fire({
        icon: 'warning',
        title:
          'Filter applied for pending users, do you want to continue anyway?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#f26868',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Remove Filter',
        toast: true,
      }).then((result) => {
        if (result.isDismissed) {
          handleConfirmPendingUsers();
        }
      });
    } else if ((tabIndex === 1 || tabIndex === 2) && filterAppliedForCompletedUsers) {
      Swal.fire({
        icon: 'warning',
        title:
          'Filter applied for completed users, do you want to continue anyway?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: '#229945',
        cancelButtonColor: '#f26868',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Remove Filter',
        toast: true,
      }).then((result) => {
        if (result.isDismissed) {
          handleConfirmCompletedUsers();
        }
      });
    } else {
      fetchDetailsBasedOnStates();
    }
  }, [tabIndex, filterAppliedForWaitingUsers, filterAppliedForCompletedUsers]);

  useEffect(() => {
    if (props?.isRefreshed) {
      localStorage.removeItem('filterAppliedForCompletedUsers');
      localStorage.removeItem('isFilterAppliedForWaitingUsers');
    }
  }, [props?.isRefreshed]);
  const handleChange = (event) => {
    const { value } = event.target;
    setQuery(value);
  };
  const nextUpcomingPage = (page) => {
    const nextPageValue = {
      page,
      limit: 10,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      plantCode: filters.plantCode,
      mobileNumber: filters.mobileNumber,
    };
    dispatch(getAllNewUserPendingHprDfRequestDetailsByType(nextPageValue));
  };
  const handleOnExportExcelRecords = (value) => {
    const exportValues = {
      fromDate: filters.fromDate,
      page: 1,
      limit: 10,
      toDate: filters.toDate,
      plantCode: filters.plantCode,
      mobileNumber: filters.mobileNumber,
      requestType: tabIndex === 0 ? 'pending' : tabIndex === 1 ? 'completed' : 'rejected',
      regionName: filters.regionName,
      vendorCode: filters.vendorCode,
    };

    if (value === 1) {
      setIsExportLoading(true);
      dispatch(exportHprDfUsers(exportValues)).finally(() => {
        setIsExportLoading(false);
      });
    }
  };

  const handleOnExportRecordsExcel = () => {
    // Determine the type based on the current tab
    const type = tabIndex === 0 ? 'pending' : 'completed';
    setIsFarmerExportLoading(true);
    dispatch(exportVetExcel(type))
      .finally(() => {
        setIsFarmerExportLoading(false);
      });
  };
  const previousUpcomingPage = (page) => {
    const previousUpcomingPageValue = {
      page,
      limit: 10,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      plantCode: filters.plantCode,
      mobileNumber: filters.mobileNumber,
    };
    dispatch(
      getAllNewUserPendingHprDfRequestDetailsByType(previousUpcomingPageValue),
    );
  };

  const nextPastHeldPage = (page, requestType) => {
    const nextPageValue = {
      page,
      limit: 10,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      plantCode: filters.plantCode,
      mobileNumber: filters.mobileNumber,
      requestType,
    };
    dispatch(getAllNewUserCompletedHprDfRequestDetailsByType(nextPageValue));
  };

  const previousPastHeldPage = (page, requestType) => {
    const nextPageValue = {
      page,
      limit: 10,
      fromDate: filters.fromDate,
      toDate: filters.toDate,
      plantCode: filters.plantCode,
      mobileNumber: filters.mobileNumber,
      requestType,
    };
    dispatch(getAllNewUserCompletedHprDfRequestDetailsByType(nextPageValue));
  };
  const handleOnSearch = async () => {
    let searchValues;
    Swal.fire({
      toast: true,
      icon: 'warning',
      title: 'Are you in search of a vendor code?',
      showCancelButton: true,
      cancelButtonColor: '#d33',
      confirmButtonColor: 'green',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((res) => {
      if (res?.isConfirmed) {
        searchValues = {
          vendorCode: query,
          page: 1,
          limit: 10,
        };
      } else if (isValidIndianPhoneNumber(query)) {
        searchValues = {
          phone: query,
          page: 1,
          limit: 10,
        };
      } else if (isValidName(query)) {
        searchValues = {
          farmerName: query,
          page: 1,
          limit: 10,
        };
      }
      if (tabIndex === 0) {
        setTabIndex(0);
        dispatch(searchByPhonePendingNewUsers(searchValues));
      } else if (tabIndex === 1 || tabIndex === 2) {
        // setTabIndex(1);
        dispatch(searchByPhoneCompletedNewUsers(searchValues));
      }
    });
  };

  const handleOnFilter = () => {
    setshowFilterModal(!showFilterModal);
  };

  const submitFilter = (e) => {
    const filterValues = {
      page: 1,
      limit: 10,
      fromDate: moment(e.fromDate).format('DD/MM/YYYY'),
      plantCode: e?.plantCode === 'Choose here' ? null : e?.plantCode,
      regionName: e?.regionName === 'Choose here' ? null : e?.regionName,
      mobileNumber: e?.mobileNumber === 'Choose here' ? null : e?.mobileNumber,
      toDate: moment(e.toDate).format('DD/MM/YYYY'),
    };
    setFilters(filterValues);
    if (tabIndex === 0) {
      dispatch(filterNewUserHprDfUsersPendingrequests(filterValues));
      localStorage.setItem('isFilterAppliedForWaitingUsers', true);
    } else if (tabIndex === 1) {
      filterValues.requestType = 'completed';
      dispatch(filterNewUserHprDfUsersCompletedrequests(filterValues));
      localStorage.setItem('isFilterAppliedForCompletedUsers', true);
    } else if (tabIndex === 2) {
      filterValues.requestType = 'rejected';
      dispatch(filterNewUserHprDfUsersCompletedrequests(filterValues));
      localStorage.setItem('isFilterAppliedForCompletedUsers', true);
    }
  };
  const handleOnBackPress = () => {
    if (tabIndex === 0) {
      dispatch(getAllNewUserPendingHprDfRequestDetailsByType(values));
    } else if (tabIndex === 1) {
      dispatch(getAllNewUserCompletedHprDfRequestDetailsByType(values));
    }
  };

  return (
    <>
      <div className="admin-orders">
        {tabIndex === 0 && filterAppliedForWaitingUsers ? (
          <div className="filterAppliedFlag">
            <FontAwesomeIcon icon={faWarning} style={{ marginRight: 5 }} />
            In order to dynamically remove the filter that has been applied to pending users, please refresh the page.
          </div>
        ) : (tabIndex === 1 || tabIndex === 2) && filterAppliedForCompletedUsers ? (
          <div className="filterAppliedFlag">
            <FontAwesomeIcon icon={faWarning} style={{ marginRight: 5 }} />
            In order to dynamically remove the filter that has been applied to completed users, please refresh the page.
          </div>
        ) : null}
        <div className="row">
          <div className="col-12">
            <div className="heading" onClick={handleOnBackPress}>
              <p className="heading__title">
                <FontAwesomeIcon icon={faChevronLeft} />
                {' '}
                Pending New HPR/DF
                Registrations
              </p>
            </div>
            <div className="buttons">
              <button
                type="button"
                className="button primary"
                onClick={handleOnFilter}
              >
                <FontAwesomeIcon icon={faFilter} className="button__icon" />
                Filter
              </button>
              <button
                type="button"
                className="button green"
                onClick={() => handleOnExportExcelRecords(1)}
              >
                {isExportLoading ? (
                  <>
                    <Spinner />
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
                    Export
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
        <Tabs
          defaultIndex={0}
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
        >
          <TabList className="row between tab-list">
            <>
              <Tab className="col-4 tab">
                <div className={`type-card ${tabIndex === 0 ? 'selected' : ''}`}>
                  Waiting for Approval
                  {
                (count > 0 && tabIndex === 0) ? (
                  <span className="count-ui danger">
                    {formatCount(count)}
                    {/* <CountUp start={0} end={formatCount(count?.countedDigitalRegistrations?.pendingCount)} duration={3} /> */}
                  </span>
                ) : null
              }

                </div>
              </Tab>
              <Tab className="col-4 tab">
                <div className={`type-card ${tabIndex === 1 ? 'selected' : ''}`}>
                  Completed
                  {(count > 0 && tabIndex === 1) ? (
                    <span className="count-ui">
                      {formatCount(count)}
                      {/* <CountUp start={0} end={formatCount(count?.countedDigitalRegistrations?.approvedCount)} duration={3} /> */}
                    </span>
                  ) : null}

                </div>
              </Tab>
              <Tab className="col-4 tab">
                <div className={`type-card ${tabIndex === 2 ? 'selected' : ''}`}>
                  Rejected
                </div>
              </Tab>
            </>
          </TabList>
          <TabPanel className="appointments-tab-panel">
            <div className="row sss">
              {upcoming && upcoming.paginate && upcoming.paginate.length
                ? upcoming.paginate.map((item, index) => (
                  <div className="col-12 col-lg-12" key={item.id || index}>
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          {item?.profilePicture ? (
                            <img src={item?.profilePicture} alt="order" />
                          ) : (
                            <img src={logoImg} alt="user" />
                          )}
                        </div>
                        <div className="row between col-9">
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                HPR / DF Name :
                                {' '}
                              </span>
                              {item ? item?.hprOrDfName : ''}
                            </div>
                            <div>
                              <span className="card__title">
                                Registration ID :
                                {' '}
                              </span>
                              {item ? item?.id : ''}
                            </div>
                            <div>
                              <span className="card__title">Phone: </span>
                              {item ? item?.mobileNumber : ''}
                            </div>
                            <div>
                              <span className="card__title">Role: </span>
                              {item
                                ? item?.hprOrDf === 'HPR'
                                  ? 'HP Representative'
                                  : 'Dairy Farmer'
                                : ''}
                            </div>
                          </div>
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                User Created At :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format(
                                'DD/MM/YYYY',
                              )}
                            </div>
                            <div>
                              <span className="card__title">
                                Plant Code :
                                {' '}
                              </span>
                              {item?.plantCode ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                MCC Name
                                {' '}
                              </span>
                              {item?.mccName ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                User Created Time :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format('hh:mm a')}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card__right">
                        {/* {item?.isEqualGenerated === true && (
                          <div className="card__text--success">
                            <span className="card__title">
                              E-KYC DONE
                              {' '}
                            </span>
                            <FontAwesomeIcon icon={faCheckCircle} />
                          </div>
                        )} */}
                        {role === 'admin'
                        || role === 'ea_pi'
                        || role === 'regional_pi'
                        || role === 'regional_fa' ? (
                          <Link
                            to={`/admin/hprordf/${item?.id}`}
                            className="card__button"
                          >
                            View
                          </Link>
                          ) : (
                            <Link
                              to={`/plant-admin/pendingHpcRegistrations/${item?.id}`}
                              className="card__button"
                            >
                              View
                            </Link>
                          )}
                      </div>
                    </div>
                  </div>
                ))
                : null}
              {!isLoading && !upcoming && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="notFound__icon"
                    />
                    <span className="notFound__text">
                      No upcoming user Request found
                    </span>
                  </div>
                </div>
              )}
            </div>
            {upcoming ? (
              <div className="row">
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="pagination">
                    <button
                      type="button"
                      className="pagination__btn"
                      disabled={!upcoming.Previous}
                      onClick={() => previousUpcomingPage(upcoming.Previous.page)}
                    >
                      <FontAwesomeIcon
                        icon={faChevronLeft}
                        className="pagination__btn__icon"
                      />
                    </button>
                    <span className="pagination__page">
                      {upcoming.Next
                        ? upcoming.Next.page - 1
                        : upcoming.Previous
                          ? upcoming.Previous.page + 1
                          : 1}
                    </span>
                    <button
                      type="button"
                      className="pagination__btn"
                      disabled={!upcoming.Next}
                      onClick={() => nextUpcomingPage(upcoming.Next.page)}
                    >
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className="pagination__btn__icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </TabPanel>
          <TabPanel className="appointments-tab-panel">
            <div className="row">
              {pastHeld && pastHeld.paginate && pastHeld.paginate.length
                ? pastHeld.paginate.filter((item) => !isRejected(item)).map((item, index) => (
                  <div className="col-12 col-lg-12" key={item.id || index}>
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          {item?.profilePicture ? (
                            <img src={item?.profilePicture} alt="order" />
                          ) : (
                            <img src={logoImg} alt="user" />
                          )}
                        </div>
                        <div className="row between col-9">
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                Farmer Name :
                                {' '}
                              </span>
                              {item ? item?.hprOrDfName : ''}
                            </div>
                            <div>
                              <span className="card__title">
                                Registration ID :
                                {' '}
                              </span>
                              {item ? item?.id : ''}
                            </div>
                            <div>
                              <span className="card__title">Phone: </span>
                              {item ? item?.mobileNumber : ''}
                            </div>
                            <div>
                              <span className="card__title">Role: </span>
                              {item
                                ? item?.hprOrDf === 'HPR'
                                  ? 'HP Representative'
                                  : 'Dairy Farmer'
                                : ''}
                            </div>
                            {item?.status === 'rejected'
                              && (item?.plantIcRejectionReason || item?.rhpiRejectionReason || item?.rifaRejectionReason || item?.eapiRejectionReason) && (
                                <div>
                                  <span className="card__title">
                                    Reason:
                                    {' '}
                                  </span>
                                  <span className="card__text--danger">
                                    {item ? (item?.plantIcRejectionReason || item?.rhpiRejectionReason || item?.rifaRejectionReason || item?.eapiRejectionReason) : ''}
                                  </span>
                                </div>
                            )}
                          </div>
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                User Created At :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format(
                                'DD/MM/YYYY',
                              )}
                            </div>
                            <div>
                              <span className="card__title">
                                Plant Code :
                                {' '}
                              </span>
                              {item?.plantCode ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                MCC Name :
                                {' '}
                              </span>
                              {item?.mccName ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                User Created Time :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format('hh:mm a')}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card__right">
                        {/* <div
                          className={`card__text--${
                            item?.status === 'approved'
                              ? 'success'
                              : item?.status === 'pending'
                                ? 'warning'
                                : item?.status === 'rejected'
                                  ? 'danger'
                                  : ''
                          }`}
                        >
                          <span className="card__title">Status : </span>
                          {item?.status?.toUpperCase()}
                        </div> */}
                        {role === 'admin'
                        || role === 'ea_pi'
                        || role === 'regional_pi'
                        || role === 'regional_fa' ? (
                          <Link
                            to={`/admin/hprordf/${item?.id}`}
                            className="card__button"
                          >
                            View
                          </Link>
                          ) : (
                            <Link
                              to={`/plant-admin/pendingHpcRegistrations/${item?.id}`}
                              className="card__button"
                            >
                              View
                            </Link>
                          )}
                      </div>
                    </div>
                  </div>
                ))
                : null}
              {!isLoading && !pastHeld && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="notFound__icon"
                    />
                    <span className="notFound__text">
                      No past held users found
                    </span>
                  </div>
                </div>
              )}
            </div>
            {pastHeld ? (
              <div className="row">
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="pagination">
                    <button
                      type="button"
                      className="pagination__btn"
                      disabled={!pastHeld.Previous}
                      onClick={() => previousPastHeldPage(pastHeld.Previous.page, 'Completed')}
                    >
                      <FontAwesomeIcon
                        icon={faChevronLeft}
                        className="pagination__btn__icon"
                      />
                    </button>
                    <span className="pagination__page">
                      {pastHeld.Next
                        ? pastHeld.Next.page - 1
                        : pastHeld.Previous
                          ? pastHeld.Previous.page + 1
                          : 1}
                    </span>
                    <button
                      type="button"
                      className="pagination__btn"
                      disabled={!pastHeld.Next}
                      onClick={() => nextPastHeldPage(pastHeld.Next.page, 'Completed')}
                    >
                      <FontAwesomeIcon
                        icon={faChevronRight}
                        className="pagination__btn__icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </TabPanel>
          <TabPanel className="appointments-tab-panel">
            <div className="row">
              {pastHeld && pastHeld.paginate && pastHeld.paginate.length
                ? pastHeld.paginate.filter((item) => isRejected(item)).map((item, index) => (
                  <div className="col-12 col-lg-12" key={item.id || index}>
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          {item?.profilePicture ? (
                            <img src={item?.profilePicture} alt="order" />
                          ) : (
                            <img src={logoImg} alt="user" />
                          )}
                        </div>
                        <div className="row between col-9">
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                HPR or DF Name :
                                {' '}
                              </span>
                              {item ? item?.hprOrDfName : ''}
                            </div>
                            <div>
                              <span className="card__title">
                                Registration ID :
                                {' '}
                              </span>
                              {item ? item?.id : ''}
                            </div>
                            <div>
                              <span className="card__title">Phone: </span>
                              {item ? item?.mobileNumber : ''}
                            </div>
                            <div>
                              <span className="card__title">Role: </span>
                              {item
                                ? item?.hprOrDf === 'HPR'
                                  ? 'HP Representative'
                                  : 'Dairy Farmer'
                                : ''}
                            </div>
                            {(item?.plantIcRejectionReason || item?.rhpiRejectionReason || item?.rifaRejectionReason || item?.eapiRejectionReason) && (
                              <div>
                                <span className="card__title">
                                  Rejected Reason:
                                  {' '}
                                </span>
                                <span className="card__text--danger">
                                  {item ? (item?.plantIcRejectionReason || item?.rhpiRejectionReason || item?.rifaRejectionReason || item?.eapiRejectionReason) : ''}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="card__text">
                            <div>
                              <span className="card__title">
                                User Created At :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format(
                                'DD/MM/YYYY',
                              )}
                            </div>
                            <div>
                              <span className="card__title">
                                Plant Code :
                                {' '}
                              </span>
                              {item?.plantCode ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                MCC Name :
                                {' '}
                              </span>
                              {item?.mccName ?? 'N/A'}
                            </div>
                            <div>
                              <span className="card__title">
                                User Created Time :
                                {' '}
                              </span>
                              {moment(item?.createdAt).format('hh:mm a')}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card__right">
                        {role === 'admin'
                        || role === 'ea_pi'
                        || role === 'regional_pi'
                        || role === 'regional_fa' ? (
                          <Link
                            to={`/admin/hprordf/${item?.id}`}
                            className="card__button"
                          >
                            View
                          </Link>
                          ) : (
                            <Link
                              to={`/plant-admin/hprordf/${item?.id}`}
                              className="card__button"
                            >
                              View
                            </Link>
                          )}
                      </div>
                    </div>
                  </div>
                ))
                : null}
              {!isLoading && !pastHeld && (
                <div className="col-12 col-lg-12 d-flex-col middle">
                  <div className="notFound">
                    <FontAwesomeIcon
                      icon={faCalendarAlt}
                      className="notFound__icon"
                    />
                    <span className="notFound__text">
                      No past held users found
                    </span>
                  </div>
                </div>
              )}
            </div>
          </TabPanel>
        </Tabs>
        {showFilterModal ? (
          <ModalForHprFilter
            show={showFilterModal}
            toggle={handleOnFilter}
            onSubmit={submitFilter}
            // values={data}
          />
        ) : null}
      </div>
      <LoadingModal show={isLoading} />
    </>
  );
};

export default withScreenRefreshDetection(pendingHprDfRegistration);
